import React from "react";
import useNotifications from "../hooks/useNotifications";
import { FaBell } from "react-icons/fa";
import { Badge } from "antd";
import { Link } from "react-router-dom";
import AccessTo from "../is-show/AccessTo";
import { CM, FL, PA, PFA, SM } from "../../pages/router/AddRoutesJson";

const Notification = () => {
  const { data: notifications = [] } = useNotifications({
    refetchInterval: 30000, // Fetch every 3 seconds
    refetchOnWindowFocus: true, // Fetch on window focus
  });
  let readCount;
  if (notifications.length) {
    readCount = notifications.filter((n) => n.read_status === "true").length;
  }
  return (
    <div>
      <AccessTo role={[PA, FL, CM, SM]}>
        <Link
          to="/activity-log"
          className="text-[6px] relative bottom-[-3px] mx-4"
        >
          <Badge count={readCount} size="default">
            <FaBell color="#99BCE3" size={19} />
          </Badge>
        </Link>
      </AccessTo>
    </div>
  );
};

export default Notification;
